import { PropertyFilterProps } from "@amzn/awsui-components-react/polaris";
import { ExtendedFilteringProperty } from "components/server-side-table/definitions";
import { Document } from "models/schemas";
import {
  SearchDocumentRequest,
  SearchDocumentResponse,
} from "components/documents-table-os/definitions";
import { commonPropertyFilterI18nStrings } from "utils/table-utils";

export interface NavigationItem {
  text: string;
  href?: string;
  parentId: string;
}

export interface MoveFoldersModalOSProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  selectedFiles: Document[];
  teamName: string;
  onMove: (files: Document[], targetParentId: string) => Promise<void>;
  searchDocuments: (
    params: SearchDocumentRequest,
  ) => Promise<SearchDocumentResponse>;
}

export const propertyFilterI18nStrings: PropertyFilterProps.I18nStrings = {
  ...commonPropertyFilterI18nStrings,
  filteringPlaceholder: "Search folders...",
};

export const FOLDER_FILTERING_PROPERTIES: ExtendedFilteringProperty[] = [
  {
    propertyLabel: "Folder name",
    key: "fileName",
    groupValuesLabel: "Folder names",
    operators: [":", "!:", "=", "!=", "^", "!^"],
    fieldType: "text",
  },
];
